import { render } from "./i-check.vue?vue&type=template&id=93327a92"
import script from "./i-check.vue?vue&type=script&lang=js"
export * from "./i-check.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__